import React, { useEffect, useState } from 'react'
import { UspConfigurationCreditAppInterestLevelView } from '../../../models'
import { useSearchInterestLevelsMutation } from '../../../services'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import LeadsInterestLevelsTable from './components/LeadsInterestLevelsTable'
import AddEditInterestLevelsModal from './components/AddEditInterestLevelsModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsLeadsInterestLevels = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchInterestLevels, { data, isLoading }] = useSearchInterestLevelsMutation()
  const [interestLevelsData, setInterestLevelsData] = useState<UspConfigurationCreditAppInterestLevelView[]>([])

  const handleSubmit = (values?: any) => {
    searchInterestLevels({
      uspConfigurationCreditAppInterestLevelView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setInterestLevelsData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Credit App Interest Level'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
            Add new
          </Button>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='Credit App Interest Level' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <LeadsInterestLevelsTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={interestLevelsData}
                      setData={setInterestLevelsData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditInterestLevelsModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCreditAppInterestLevelView}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsLeadsInterestLevels
